import {CordwoodMeasurementType} from "../timber/types/models/CordwoodMeasurementType.d";

export function calcVolumeM3(
    volume: number,
    measurementType: CordwoodMeasurementType,
): number {
    const PRM_TO_M3 = 0.7;
    const NPM_TO_M3 = 0.5;

    switch (measurementType) {
        case CordwoodMeasurementType.m3:
            return volume;
        case CordwoodMeasurementType.prm:
            return volume * PRM_TO_M3;
        case CordwoodMeasurementType.npm:
            return volume * NPM_TO_M3;
        default: {
            return volume;
        }
    }
}